import React from 'react';
import styled from 'styled-components';
import EmailIcon from 'components/icons/Email';
import ClickableText from 'components/ClickableText';
import { Trans } from 'react-i18next';
import ContactSupport from 'pages/landing/ContactSupport';
import { DEFAULT_THEME_COLOR } from 'appenv';
import { useSelector } from 'react-redux';
import LandingModalTitle from './LandingModalTitle';

const EmailSentContactSupportContainer = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: flex-end;
`;

const EmailSentTitle = styled(LandingModalTitle)`
  color: #484848;
`;

const EmailSentContainer = styled.div`
  text-align: center;
  color: #484848;
  fill: #484848;
  margin: 1.2em 16px 0;

  & > svg > path {
    fill: #DBDEE2;
  }
`;

const BoldText = styled.span`
  font-weight: bold;
`;

interface EmailSentProps {
  email: string;
  showEmailInput: () => void;
  handleClose: () => void;
}

const EmailSentMessageView = ({ email, showEmailInput, handleClose }: EmailSentProps) => {
  const themeColor = useSelector((s) => (s as any).eventConfigs.themeColor);
  const resolvedColor = themeColor || DEFAULT_THEME_COLOR;

  return (
    <>
      <EmailSentContainer>
        <EmailIcon width={69} height={60} alt="Email Illustration" />
        <EmailSentTitle id="email-sent-title">
          <Trans i18nKey="lobby.registration.check_mailbox" defaults="Check your mailbox" />
        </EmailSentTitle>
        <p>
          <Trans
            i18nKey="lobby.registration.sending_email"
            values={{ email }}
            components={{ b: <BoldText /> }}
            defaults="We are emailing you at <b>%{email}</b> with the access link."
          />
        </p>
        <p>
          <Trans
            i18nKey="lobby.registration.not_received_msg"
            values={{ minute: 10 }}
            components={{ b: <BoldText />, a: <ClickableText onClick={showEmailInput} color={resolvedColor} /> }}
            defaults="If you have not received it in <b>%{minute} minutes</b>, please <a>try again</a>"
          />
        </p>
      </EmailSentContainer>
      <EmailSentContactSupportContainer>
        <ContactSupport handleClose={handleClose} />
      </EmailSentContactSupportContainer>
    </>
  );
};

export default EmailSentMessageView;
